import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationDialog, Toast } from '@aurrica-web/ui';

@Component({
  imports: [RouterOutlet, Toast, ConfirmationDialog],
  selector: 'app-root',
  template: `
    <router-outlet />
    <lib-ui-toast />
    <lib-ui-confirmation-dialog />
  `,
})
export class App {}
